<template>
  <Vue100vh>
    <div id="app" class="fill-space">
      <component :is="layout" class="fill-space">
        <router-view class="fill-space scrollable" />
      </component>
    </div>
  </Vue100vh>
</template>

<script>
  import Vue100vh from 'vue-div-100vh';

  export default {
    name: 'app',
    components: {
      Vue100vh,
    },
    data() {
      return {
        isAndroid: false,
      };
    },
    computed: {
      layout() {
        return `${this.$route.meta.layout || 'default'}-layout`;
      },
    },
  };
</script>

<style lang="scss">
  @import './assets/styles/globals.scss';

  body {
    margin: 0;
  }

  #app {
    font-family: var(--font-family-default);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--color-text-dark);
  }

  .fill-space {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  .scrollable {
    overflow-y: scroll;
  }
</style>
